// eslint-disable-next-line
import * as React from "react";
import { Link } from "react-router-dom";
import { FaGithubSquare, FaLinkedin, FaTwitterSquare } from "react-icons/fa";

function Resume() {
  return (
    <div className="body">
      <div className="flex space-between">
        <div className="social-links-sm">
          <a
            href="https://github.com/srishti-maurya"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithubSquare size={25} />
          </a>
          <a
            href="https://www.linkedin.com/in/mauryasrishti22/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin size={25} />
          </a>
          <a
            href="https://twitter.com/SrishtiMaurya1?s=09"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitterSquare size={25} />
          </a>
        </div>
        <div className="download-resume">
          <Link to="/resources/Srishti_Maurya_CV.pdf" target="_blank" download>
            <div className="img-container-xs">
              <img
                src="./images/download.png"
                className="coding"
                alt="about-img"
              />
            </div>
          </Link>
        </div>
      </div>
      <h1 className="light-sec">Education</h1>
      <div className="resume-div ">
        <img alt="education-img" src="./images/education.png" />
        <div className="tech-container">
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1">
                Lovely Professional University, Punjab
              </div>
              <p className="head-2">
                <i> B.Tech (CSE) (2017-2021)</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1"> Lions School, Mirzapur (U.P.)</div>
              <p className="head-2">
                <i> 10+2 (2016-2017)</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1">St. Mary's School, Mirzapur (U.P.)</div>
              <p className="head-2">
                <i> 10 (2014-2015)</i>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="resume-div-dark margin-sm">
        <h1 className="dark-sec">Where I’ve Worked</h1>
        <div className="resume-div">
          <div className="tech-container">
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light">Software Engineer</div>
                <p className="head-2 light">
                  <i>
                    Coditation, Pune <br />
                    Nov 2022 - Present
                  </i>
                </p>
              </div>
            </div>
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light">React-Native Developer</div>
                <p className="head-2 light">
                  <i>
                    Crownstack, Gurgaon <br />
                    Sept 2021 - Nov 2022
                  </i>
                </p>
              </div>
            </div>
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light">
                  Head of Planning and Development
                </div>
                <p className="head-2 light">
                  <i>
                    Student Organization - SPADE (Lovely Professional
                    University)
                    <br />
                    May 2019- March 2020
                  </i>
                </p>
              </div>
            </div>
          </div>
          <img alt="workplace-img" src="./images/workplace.png" />
        </div>
      </div>

      <h1 className="light-sec">My Blogs</h1>
      <div className="resume-div">
        <img alt="volunteer-img" src="./images/blog.png" />
        <div className="tech-container">
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <a
                href="https://srishtimaurya.hashnode.dev/promises-in-javascript"
                target="_blank"
                className="head-1 external-link"
                rel="noreferrer"
              >
                Promises In JavaScript
              </a>
              <p className="head-2">
                <i>May 1, 2022 (8 min read)</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <a
                href="https://srishtimaurya.hashnode.dev/function-borrowing-in-js"
                target="_blank"
                className="head-1 external-link"
                rel="noreferrer"
              >
                Function Borrowing in JS
              </a>
              <p className="head-2">
                <i>May 10, 2022 (3 min read)</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <a
                href="https://srishtimaurya.hashnode.dev/useeffect-in-react"
                target="_blank"
                className="head-1 external-link"
                rel="noreferrer"
              >
                useEffect() in React
              </a>
              <p className="head-2">
                <i>Nov 16, 2022 (4 min read)</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <a
                href="https://srishtimaurya.hashnode.dev/understanding-redux-with-counter-app"
                target="_blank"
                className="head-1 external-link"
                rel="noreferrer"
              >
                Understanding Redux with Counter App
              </a>
              <p className="head-2">
                <i>Dec 6, 2022 (4 min read)</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <a
                href="https://srishtimaurya.hashnode.dev/flatlist-in-react-native"
                target="_blank"
                className="head-1 external-link"
                rel="noreferrer"
              >
                Flatlist in React Native
              </a>
              <p className="head-2">
                <i>Jan 15, 2023 (2 min read)</i>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="resume-div-dark margin-sm">
        <h1 className="dark-sec">Volunteer Experience</h1>
        <div className="resume-div">
          <div className="tech-container">
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light">Smart India Hackathon </div>
                <p className="head-2">
                  <i>
                    Organized by - Smart India Hackathon
                    <br />
                    Volunteer (March 2019) <br /> Cause- Science and Technology
                  </i>
                </p>
              </div>
            </div>
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light">Freshmen Induction 2019</div>
                <p className="head-2">
                  <i>
                    Organized By - Lovely Professional University
                    <br />
                    Student Coordinator (Jul 2019 – Aug 2019) <br /> Cause- Arts
                    and Culture
                  </i>
                </p>
              </div>
            </div>
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light">Event: Road to 5G Security</div>
                <p className="head-2">
                  <i>
                    Student Organization - SPADE (Lovely Professional
                    University)
                    <br />
                    Coordinator (Aug 2019) <br /> Cause- Education
                  </i>
                </p>
              </div>
            </div>
          </div>
          <img alt="volunteer-img" src="./images/team.png" />
        </div>
      </div>

      <h1 className="light-sec">Certificates</h1>
      <div className="resume-div">
        <img alt="certificate-img" src="./images/certificate.png" />
        <div className="tech-container">
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1"> Lean Management</div>
              <p className="head-2">
                <i>By - Simplilearn</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1">
                The Indian Science Congress Association (Participant)
              </div>
              <p className="head-2">
                <i>By - The Indian Science Congress Association</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1">
                Cyber Disease- Ethical Hacking & Cyber Security
              </div>
              <p className="head-2">
                <i>By - i3indya Technologies</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1"> Fundamentals of Python</div>
              <p className="head-2">
                <i>By - Acadview</i>
              </p>
            </div>
          </div>
          <div className="points">
            <img
              src="./images/arrow.png"
              className="arrow-pointer"
              alt="about-img"
            />
            <div className="mt-05">
              <div className="head-1"> Networking Fundamentals</div>
              <p className="head-2">
                <i>By - Microsoft</i>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="resume-div-dark margin-sm">
        <h1 className="dark-sec">Accomplishments</h1>

        <div className="resume-div">
          <div className="tech-container">
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light">
                  Short Term Course : The Art of Virtual Teaching
                </div>
                <p className="head-2 light">
                  <i>
                    Participated as Program Facilitator
                    <br />
                    Organized by Lovely Professional University (October 2020)
                  </i>
                </p>
              </div>
            </div>
            <div className="points">
              <img
                src="./images/arrow.png"
                className="arrow-pointer"
                alt="about-img"
              />
              <div className="mt-05">
                <div className="head-1 light"> Student Council Member</div>
                <p className="head-2 light">
                  <i>Lions School (2015-2016)</i>
                </p>
              </div>
            </div>
          </div>
          <img alt="workplace-img" src="./images/success.png" />
        </div>
      </div>
    </div>
  );
}

export default Resume;
